import React from "react";
import DeepScalperImage from "../assets/DeepScalper.jpg";
import KDD23 from "../assets/KDD23.jpg";
import RPRUDEXCompassImage from "../assets/RPRUDEX-Compass.png";
import wealthGraphImage from "../assets/wealthGraph.jpg";
import surveyImage from "../assets/surveyImage.jpg";
import externalLinkIcon from "../assets/icons8-external-link.svg";
import RL4QT from "../assets/RL4QT.jpg";
import "../styles/Research.css";
import EarnHFTPipline from "../assets/photo1.png";
import EarnHFTPipline2 from "../assets/photo2.png";
import month_record_1 from "../assets/month_record_-1.png";
import month_record_2 from "../assets/month_record_-2.png";
import month_record_3 from "../assets/month_record_-3.png";
import month_record_4 from "../assets/month_record_-4.png";
import strategy_1 from '../assets/strategy_-1.pkl';
import strategy_2 from '../assets/strategy_-2.pkl';
import strategy_3 from '../assets/strategy_-3.pkl';
import strategy_4 from '../assets/strategy_-4.pkl';

export default function EarnHFT() {
    return (
        <div>
            <div className="aa">
                <div className="topa">
                    <div className="form-floating">
                        <h3 style={{ fontSize: "42px", textAlign: "center", fontWeight: 700 }}>
                            Key Features
                        </h3>
                    </div>

                    <br />
                    <h5 style={{ fontSize: "30px", textAlign: "justify", fontWeight: 300 }}>
                        (1) We introduce a market decomposition method using trend and volatility indicators to enhance the specialization of sub-agents trained on decomposed market data.
                    </h5>
                    <h5 style={{ fontSize: "30px", textAlign: "justify", fontWeight: 300 }}>
                        (2) We propose low-level policy optimization with conditional adaptation for sub-agents, enabling efficient adjustments of trading policies according to market conditions.
                    </h5>
                    <h5 style={{ fontSize: "30px", textAlign: "justify", fontWeight: 300 }}>
                        (3) We develop a hyper-agent that provides a meta-policy to effectively integrate diverse low-level policies from sub agents. Utilizing a memory module, the hyper-agent can formulate a robust trading strategy by learning from highly relevant experiences.
                    </h5>
                    <br />
                    <img src={EarnHFTPipline} alt="EarnHFT pipeline" className="img-fluid" />
                </div>
            </div>
            <div className='container' style={{marginTop:'70px'}}>

                <h3 className='History'>
                    Results
                </h3>
                <br />
                <h3 style={{ fontSize: "30px", textAlign: "center", fontWeight: 300 }}>
                    MacroHFT significantly surpasses multiple state-of-the-art RL and rule-based trading methods in profit-making while maintaining competitive risk managing ability.
                </h3>

                <br />
                {/*<div className="grid-container">*/}
                {/*    <h3 style={{ fontSize: "30px", textAlign: "center", fontWeight: 600 }}>*/}
                {/*        The result is calculated using the BTCUSDT spot trading pair from Binance, under 0 commission fee*/}
                {/*    </h3>*/}
                {/*    <img src={month_record_1} alt="month_record_1" className="img-fluid" />*/}
                {/*    <br />*/}
                {/*    <h3 style={{ fontSize: "38px", textAlign: "center", fontWeight: 700 }}>*/}
                {/*        <a href={strategy_1}  download="strategy_-1.pkl" style={{ color: "blue", textDecoration: "underline" }}>*/}
                {/*            Download Strategy 1*/}
                {/*        </a>*/}
                {/*    </h3>*/}
                {/*    <br />*/}
                {/*    <img src={month_record_2} alt="month_record_2" className="img-fluid" />*/}
                {/*    <br />*/}
                {/*    <h3 style={{ fontSize: "38px", textAlign: "center", fontWeight: 700 }}>*/}
                {/*        <a href={strategy_2} download="strategy_-2.pkl" style={{ color: "blue", textDecoration: "underline" }}>*/}
                {/*            Download Strategy 2*/}
                {/*        </a>*/}
                {/*    </h3>*/}
                {/*    <br />*/}
                {/*    <img src={month_record_3} alt="month_record_3" className="img-fluid" />*/}
                {/*    <br />*/}
                {/*    <h3 style={{ fontSize: "38px", textAlign: "center", fontWeight: 700 }}>*/}
                {/*        <a href={strategy_3} download="strategy_-3.pkl" style={{ color: "blue", textDecoration: "underline" }}>*/}
                {/*            Download Strategy 3*/}
                {/*        </a>*/}
                {/*    </h3>*/}
                {/*    <br />*/}
                {/*    <img src={month_record_4} alt="month_record_4" className="img-fluid" />*/}
                {/*    <br />*/}
                {/*    <h3 style={{ fontSize: "38px", textAlign: "center", fontWeight: 700 }}>*/}
                {/*        <a href={strategy_4} download="strategy_-4.pkl" style={{ color: "blue", textDecoration: "underline" }}>*/}
                {/*            Download Strategy 4*/}
                {/*        </a>*/}
                {/*    </h3>*/}
                {/*</div>*/}
                <div >
                    <img src={EarnHFTPipline2} alt="EarnHFT pipeline" className="img-fluid" />
                </div>








            </div>
        </div>
    );
}
